import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { checkUrl } from '../../deployment';

@Injectable({
  providedIn: 'root'
})
export class EcasessionService {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  sessionList(){
    return this.http.get(checkUrl()+"/ecademic/session/list").pipe((response)=>{
      return response;
    });
  }

  //Session details
  sessionDetails($data){
    return this.http.post(checkUrl()+"/ecademic/session/details",$data)
  .pipe((response)=>{
    return response;
  });
  }
}


